import { getUsersMeCurrentPreferenceByKey } from "./getUsersMeCurrentPreferenceByKeySelector";
import { RootState } from "../../store";

export const getUsersPreferenceByKeySelector = (
  state: RootState,
  key: string,
) => {
  return getUsersMeCurrentPreferenceByKey({ key })(state)?.data;
};
